var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 13,
    viewBox: "0 0 5 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "formkit:down",
    clipPath: "url(#clip0_46_671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.357254 6.5C0.356683 6.44672 0.365921 6.39389 0.384373 6.34492C0.402826 6.29594 0.430085 6.2519 0.464397 6.21563L3.67868 2.55938C3.82154 2.39688 4.04297 2.39688 4.18583 2.55938C4.32868 2.72188 4.32868 2.97375 4.18583 3.13625L1.22154 6.50813L4.17868 9.87187C4.32154 10.0344 4.32154 10.2862 4.17868 10.4487C4.03583 10.6112 3.8144 10.6112 3.67154 10.4487L0.457254 6.7925C0.385826 6.71125 0.350111 6.60563 0.350111 6.50813L0.357254 6.5Z",
    fill: "#5B5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 5,
    fill: "white",
    transform: "matrix(0 1 -1 0 5 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowicon);
export default __webpack_public_path__ + "static/media/leftArrowicon.4e097dfbc88a43bac540338ea05a3d14.svg";
export { ForwardRef as ReactComponent };